// extracted by mini-css-extract-plugin
export default {"checkbox":"SeCheckbox_checkbox__-EHTW"};